<template>
    <div>
        <div>
        <div class="topbar-bg" v-bind:class="calcTopbarClass" ></div>
        </div>
        <div class="text-content-section stretch-vertical">
            <div v-html="pageContent"></div>
            <div class="stretch-vertical" >
                <div class="stretch-vertical"></div>
            </div>
        </div>
    </div>
</template>

<style>
    .update-info {
        margin: 10px 0px;
        text-align: right;
    }
</style>

<script>
/* eslint-disable */
import axios from 'axios'
export default {
    data() {
        return {
            pageContent: '',
            routeRoot: '',
        }
    },
    beforeRouteEnter (to, from, next) {
        const routeRoot = to.path.split('/')[1].toLowerCase();

        // https://router.vuejs.org/guide/advanced/data-fetching.html#fetching-before-navigation
        const vm = this;
        axios.get('api/pagecontent/' + to.name).then(function (response) {
            if (response.status === 200) {
                return next(vm => vm.setData(null, response.data, routeRoot));
            } 

            return next(vm => vm.setData('error', null, routeRoot));
        })
        .catch(function (error) {
            next(vm => vm.setData(error, null, routeRoot));
        });
    },
    computed: {
        calcTopbarClass: function() {
            if (this.routeRoot === 'home') {
                return 'topbar-welcome-bg';
            }
            else if (this.routeRoot.includes('arrivals')) {
                return 'topbar-arrivals-bg';
            }
            else if (this.routeRoot.includes('stay')) {
                return 'topbar-alice-springs-bg';
            }
            else if (this.routeRoot.includes('departures')) {
                return 'topbar-departures-bg';
            }
            else if (this.routeRoot.includes('forms')) {
                return 'topbar-mail-bg';
            }
            else if (this.routeRoot.includes('contact')) {
                return 'topbar-financial-bg';
            }
            else if (this.routeRoot === 'logistical') {
                return 'topbar-logistical-bg';
            }
 
            return 'topbar-tools-bg';
        }
    },
    methods: {
        setData(err, page, routeRoot) {
            this.routeRoot = routeRoot;
            if (err) {
                // an error ocurred...just navigate back home
                this.$router.push({name: 'home'});
            } else {
                var rawMarkDownText = marked(page.Content);
                var pattern = /a href=/g;
                this.pageContent = rawMarkDownText
                    .replace(pattern,"a target='_blank' href=")
                    .replaceAll('="https://itsvesta.com/', '="./')
                    .replaceAll('="https://www.itsvesta.com/', '="./')
                    .replaceAll('="https://vestaapp-staging.azurewebsites.net/', '="./');
            }
        }
    }
}
</script>
